import { render } from "./ButtonTwitter.vue?vue&type=template&id=19829358&bindings={\"text\":\"props\"}"
import script from "./ButtonTwitter.vue?vue&type=script&lang=ts"
export * from "./ButtonTwitter.vue?vue&type=script&lang=ts"
script.render = render

export default script